import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/node/CircularProgress/index.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/node/Skeleton/index.js");
import(/* webpackMode: "eager" */ "/app/src/app/(private)/(home)/page.module.scss");
import(/* webpackMode: "eager" */ "/app/src/common/ui/styles.module.scss")